export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5134.71e0e334.jpg";